import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { mountBuilder } from '../engine/builder/mount.ts';

// The anonymous "fill this form" page behind a Publish share link
// (/f/:id) — no auth, no builder chrome. Reuses the same ported engine as
// BuilderPage in `public` mode: it fetches through the unauthenticated
// /api/public/forms/:id endpoint and only ever shows the runtime/preview pane.
export default function PublicFormPage() {
  const { id } = useParams<{ id: string }>();
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = rootRef.current;
    if (!el || !id) return;
    const unmount = mountBuilder(el, id, { public: true });
    return unmount;
  }, [id]);

  return <div className="builder-root" ref={rootRef} />;
}
